import React, { useEffect, useState } from 'react';
import { Box, Container} from '@mui/material';
import axios from 'axios';
import apiUrl from '../../Config';


const UpcomingBooks = () => {
  const [upcomingBooks, setUpcomingBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  

  

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const res = await axios.get(`${apiUrl}/upcomingbooks/getallupcommingbook`);
        const activeBooks = (res.data.allBooks || []).filter(book => book.isActive);
              setUpcomingBooks(activeBooks);
          setLoading(false);
      } catch (err) {
        setUpcomingBooks([]);
        setLoading(false);
      }
    };
    fetchBooks();
  }, []);

 
  return (
    <Container maxWidth="xl" width={"80%"} sx={{ pr: "0px !important", pl: "10px !important" }}>
      <Box sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
          <h3 style={{
            fontWeight: 600,
            fontFamily: "Poppins",
            color: "#CB4422",
            borderLeft: "4px solid #000000",
            paddingLeft: 8
          }}>
            Upcoming Books
          </h3>
        </Box>
        {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <span className="red-dot" />
                                <span className="red-dot" style={{ animationDelay: '0.2s' }} />
                                <span className="red-dot" style={{ animationDelay: '0.4s' }} />
                            </Box>
                            <style>
                                {`
                                .red-dot {
                                    display: inline-block;
                                    width: 14px;
                                    height: 14px;
                                    border-radius: 50%;
                                    background: #CB4422;
                                    margin: 0 4px;
                                    animation: bounce 1s infinite;
                                }
                                @keyframes bounce {
                                    0%, 80%, 100% { transform: scale(1); opacity: 1; }
                                    40% { transform: scale(1.4); opacity: 0.7; }
                                }
                                `}
                            </style>
                        </Box>
                    ) : (
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: 2,
            pb: 1,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          {upcomingBooks.map((book) => (
            <Box
              key={book.id}
              sx={{
                minWidth: 300,
                maxWidth: 320,
                flexShrink: 0,
                cursor: 'pointer',
              }}
            >
              <img
                src={book.imageUrl}
                alt={`Upcoming Book ${book.id}`}
                style={{
                  width: '100%',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  </Container>
);
};

export default UpcomingBooks;
